// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hrfy","colBig":"styles_colBig__1sHkq","colSmall":"styles_colSmall__3IGxa"};